import { Context } from '@/context';
import { useContext } from 'react';

const useIsUserAuthenticated = () => {
    const { state } = useContext(Context);
    const { user } = state;

    return user?.logged ?? false;
};

export default useIsUserAuthenticated;
